import React from 'react';
import { motion } from 'framer-motion';
import { Play, Users, Award, Zap } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { ConfettiAnimation } from '../components/ConfettiAnimation';
interface WelcomeScreenProps {
  onNext: () => void;
}
export function WelcomeScreen({
  onNext
}: WelcomeScreenProps) {
  return <div className="relative min-h-screen flex flex-col items-center justify-center p-6 overflow-hidden bg-[#0f0f2d]" data-id="element-168">
      <ConfettiAnimation data-id="element-169" />

      <div className="max-w-4xl w-full z-10 flex flex-col items-center text-center" data-id="element-170">
        {/* Header Text */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-171">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-172">
            Welcome to <span className="text-[#a8c5e0]" data-id="element-173">ClickFunnels</span>
          </h1>
          <p className="text-xl md:text-2xl text-[#8b8bab] font-light" data-id="element-174">
            You're officially a funnel builder.
          </p>
        </motion.div>

        {/* Video Placeholder */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="w-full max-w-2xl aspect-video bg-[#1a1a3e] rounded-2xl border border-[#2a2a5a] shadow-2xl shadow-black/30 relative group cursor-pointer overflow-hidden mb-12" data-id="element-175">
          {/* Thumbnail/Placeholder Content */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a3e] to-[#0f0f2d] flex items-center justify-center" data-id="element-176">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-20 mix-blend-overlay" data-id="element-177" />

            <div className="w-20 h-20 rounded-full bg-[#ffc978] flex items-center justify-center shadow-lg shadow-[#ffc978]/30 group-hover:scale-110 transition-transform duration-300 z-10" data-id="element-178">
              <Play fill="#0f0f2d" className="text-[#0f0f2d] ml-1" size={32} data-id="element-179" />
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#0a0a1f] to-transparent" data-id="element-180">
            <p className="text-white font-medium" data-id="element-181">
              A message from Todd Dickerson
            </p>
            <p className="text-[#8b8bab] text-sm" data-id="element-182">Co-Founder, ClickFunnels</p>
          </div>
        </motion.div>

        {/* Social Proof */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="flex flex-col items-center mb-12" data-id="element-183">
          <p className="text-[#5a5a7a] text-sm uppercase tracking-widest mb-6" data-id="element-184">
            Join 100,000+ Entrepreneurs
          </p>
          <div className="flex items-center gap-8 opacity-60 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-185">
            {/* Mock Logos */}
            <div className="flex items-center gap-2 text-[#8b8bab] font-bold text-lg" data-id="element-186">
              <Zap size={20} data-id="element-187" /> PowerScale
            </div>
            <div className="flex items-center gap-2 text-[#8b8bab] font-bold text-lg" data-id="element-188">
              <Award size={20} data-id="element-189" /> EliteGrowth
            </div>
            <div className="flex items-center gap-2 text-[#8b8bab] font-bold text-lg" data-id="element-190">
              <Users size={20} data-id="element-191" /> Community
            </div>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.5
      }} data-id="element-192">
          <Button size="lg" onClick={onNext} className="text-base px-8 py-4 h-auto font-bold" data-id="element-193">
            Let's build your first funnel
          </Button>
        </motion.div>
      </div>
    </div>;
}